import React, { useEffect, useState } from "react"
import useMapState, { useMarkerState } from "~/features/Map/stores/MapState";
import { Circle, Polyline } from "react-leaflet";
import type { LatLngExpression } from "leaflet";
import { Downgraded, useHookstate } from "@hookstate/core";
import dayjs from "dayjs";
import L from "leaflet";

export default function ModalHistoricDevice() {
  const { popupMarker, loadingRouteDevice, dateTimeHistoric, markersState } = useMarkerState()
  const overviewRouteDevice = useHookstate<any | null>(null)
  const baseDate = dateTimeHistoric.attach(Downgraded).value
  const routeBeforeDateHistoric = useHookstate<any | null>(null)
  const routeAfterDateHistoric = useHookstate<any | null>(null)
  const colorRouteBefore = { color: 'red' }
  const colorRouteAfter = { color: 'green' }
  const map = useMapState().map();
  const [arrowsBefore, setArrowsBefore] = useState<any | L.FeatureGroup>();
  const [arrowsAfter, setArrowsAfter] = useState<any | L.FeatureGroup>();


  useEffect(() => {
    if (popupMarker['traceRoute']?.get()) {
      
      overviewRouteDevice.set(JSON.parse(JSON.stringify(popupMarker['traceRoute']?.attach(Downgraded).value)))
      separatingIntoBeforAndAfterDateHistoric()

      const arrowsBeforeGroup = L.featureGroup(getArrows(routeBeforeDateHistoric.get(), 'black', 1, map)).addTo(map);
      const arrowsAfterGroup = L.featureGroup(getArrows(routeAfterDateHistoric.get(), 'black', 1, map)).addTo(map);

      setArrowsBefore(arrowsBeforeGroup);
      setArrowsAfter(arrowsAfterGroup);

      popupMarker['traceRoute'].set(null)
    } else {
      removeArrows()
      overviewRouteDevice.set(null)
      routeBeforeDateHistoric.set(null)
      routeAfterDateHistoric.set(null)
    }
  }, [loadingRouteDevice.get()])

  const removeArrows = () => {
    if (arrowsBefore) {
      map.removeLayer(arrowsBefore);
      setArrowsBefore(null);
    }
    if (arrowsAfter) {
      map.removeLayer(arrowsAfter);
      setArrowsAfter(null);
    }
  };

  const separatingIntoBeforAndAfterDateHistoric = () => {
    if (overviewRouteDevice.get()) {
      overviewRouteDevice.get().map((item) => {
        dayjs(item.datePoint).isBefore(dayjs(baseDate)) ?
          routeBeforeDateHistoric.merge([[item.lat, item.lng]]) :
          routeAfterDateHistoric.merge([[item.lat, item.lng]])
      })

      if (routeBeforeDateHistoric?.get()) {
        routeAfterDateHistoric.merge([JSON.parse(JSON.stringify(routeBeforeDateHistoric?.get()[0]))])
      }
    }
  }

  function getArrows(arrLatlngs, color, arrowCount, mapObj) {

    if (typeof arrLatlngs === undefined || arrLatlngs == null ||
      (!arrLatlngs.length) || arrLatlngs.length < 2)
      return [];

    if (typeof arrowCount === 'undefined' || arrowCount == null)
      arrowCount = 1;

    if (typeof color === 'undefined' || color == null)
      color = '';
    else
      color = 'color:' + color;

    let result: any = [];
    for (let i = 1; i < arrLatlngs.length; i++) {
      let icon = L.divIcon({ className: 'arrow-icon', bgPos: [5, 5], html: '<div style="' + color + ';transform: rotate(' + getAngle(arrLatlngs[i], arrLatlngs[i - 1], -1).toString() + 'deg)">&#10148;</div>' });
      for (let c = 1; c <= arrowCount; c++) {
        result.push(L.marker(myMidPoint(arrLatlngs[i], arrLatlngs[i - 1], (c / (arrowCount + 0.001)), mapObj), { icon: icon }));
      }
    }
    return result;
  }

  function getAngle(latLng1, latlng2, coef) {
    const diffY = latlng2[0] - latLng1[0];
    const diffX = Math.cos(Math.PI / 180 * latLng1[0]) * (latlng2[1] - latLng1[1]);
    const angle = ((Math.atan2(diffY, diffX) / Math.PI) * 180 * coef);
    return (angle).toFixed(2);
  }

  function myMidPoint(latlng1, latlng2, per, mapObj) {
    if (!mapObj)
      throw new Error('map is not defined');

    const position1 = mapObj.project(L.latLng(latlng1));
    const position2 = mapObj.project(L.latLng(latlng2));

    const halfDist = distanceTo(position1, position2) * per;

    if (halfDist === 0)
      return mapObj.unproject(position1);

    const distance = distanceTo(position1, position2);

    if (distance > halfDist) {
      const ratio = (distance - halfDist) / distance;
      let result = mapObj.unproject(new Point(position2.x - ratio * (position2.x - position1.x), position2.y - ratio * (position2.y - position1.y)));
      return [result.lat, result.lng];
    }
  }

  function distanceTo(p1, p2) {
    const distanceX = p2.x - p1.x;
    const distanceY = p2.y - p1.y;

    return Math.sqrt(distanceX * distanceX + distanceY * distanceY);
  }

  function Point(this: any, positionX, positionY, round?) {
    this.x = (round ? Math.round(positionX) : positionX);
    this.y = (round ? Math.round(positionY) : positionY);
  }

  return (
    routeBeforeDateHistoric.get()?.length && routeAfterDateHistoric.get()?.length && (
      <>
        {/* <Circle
          center={[routeBeforeDateHistoric.get()[0][0], routeBeforeDateHistoric.get()[0][1]]}
          radius={10}
          pathOptions={{ color: 'red' }}
        /> */}
        <Circle
          center={[routeAfterDateHistoric.get()[routeAfterDateHistoric.get()?.length - 1][0], routeAfterDateHistoric.get()[routeAfterDateHistoric.get()?.length - 1][1]]}
          radius={10}
          pathOptions={{ color: 'green' }}
        />
        <Polyline pathOptions={colorRouteBefore} positions={routeBeforeDateHistoric.get() as LatLngExpression[]} weight={5} />
        <Polyline pathOptions={colorRouteAfter} positions={routeAfterDateHistoric.get() as LatLngExpression[]} weight={5} />
      </>
    )
  )
}